import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { accountServices } from "../../../APIServices/GlobalManagements/accountServices";

const UpdateAccount = ({ show, hide, title, getAccountList, accountData }) => {
  const [loader, setLoader] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");

  const updatedAccount = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this account?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.accountId = accountData?.accountId
        userData.name = name
        userData.description = description
        userData.status = status
        let data = await accountServices.updatedAccount(userData)
        if (data?.statusCode === 200) {
          getAccountList()
          clearData();
        }
      }
    });
  };

  const clearData = () => {
    setName("");
    setDescription("");
    setStatus("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (show && accountData) {
      setName(accountData?.name);
      setDescription(accountData?.description || "");
      setStatus(accountData?.status);
      setLoader(false)
    }
  }, [show, accountData]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Account Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="accountName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Account Name "
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Description (optional)</Form.Label>
            <Form.Control
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter Description (optional)"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Status <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              className="interactive-input"
              style={{ fontSize: 14 }}
              onChange={(e) => setStatus(e.target.value)}
              value={status}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button disabled={!name || !status || loader} onClick={updatedAccount} style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdateAccount;
